import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { VistaBanner } from "./VistaBanner";

type Props = ThemeSlotPropsMap["pageHeading"];

const IMAGE_MAP: Record<string, string> = {
  advice:
    "https://files.vistahypotheken.nl/1757656306-50861_vista_webbeelden.jpg?auto=compress",
  documentsOutgoing:
    "https://files.vistahypotheken.nl/1757656303-50861_vista_webbeelden7.jpg?auto=compress",
  documentsIncoming:
    "https://files.vistahypotheken.nl/1757656303-50861_vista_webbeelden7.jpg?auto=compress",
  interestRates:
    "https://files.vistahypotheken.nl/1754049250-home-hero-vista-hypotheken.jpg?auto=compress",
  maximumMortgage:
    "https://files.vistahypotheken.nl/1757656304-50861_vista_webbeelden5.jpg?auto=compress",
  orientation:
    "https://files.vistahypotheken.nl/1757656302-50861_vista_webbeelden2.jpg?auto=compress",
};

export const VistaPageHeading: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();

  return (
    <VistaBanner
      title={t(`${scope}Heading.title`)}
      description={t(`${scope}Heading.description`)}
      imageSrc={IMAGE_MAP[scope] ?? ""}
    />
  );
};
